import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initCause1uc19zhi9fkfi as initCause } from './internal/StackTraceRecovery.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from './Debug.common.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ScopeCoroutine2c07fgm3ekmnx as ScopeCoroutine } from './internal/Scopes.mjs';
import {
  get_delaynv5kl66dta33 as get_delay,
  DelayWithTimeoutDiagnostics19ibxwhhgbjz0 as DelayWithTimeoutDiagnostics,
} from './Delay.mjs';
import { Key_instanceipoc78w8jesn as Key_instance } from './CoroutineName.mjs';
import { Runnablezd7bpy5et5p0 as Runnable } from './Runnable.mjs';
import { disposeOnCompletion1zvxmj809ax5i as disposeOnCompletion } from './Job.mjs';
import { startUndispatchedOrReturnIgnoreTimeout3dcuyudwff859 as startUndispatchedOrReturnIgnoreTimeout } from './intrinsics/Undispatched.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Companion_getInstancevdtg3uvqmv7f as Companion_getInstance,
  toDurationba1nlt78o6vu as toDuration,
} from '../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancen5e0rps4ljgd as DurationUnit_MILLISECONDS_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { toString22rbkbhdb5cl2 as toString } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substring3saq8ornu0luv as substring } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *withTimeoutOrNull(timeMillis, block, $completion) {
  if (timeMillis <= 0n)
    return null;
  var coroutine = {_v: null};
  try {
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    return yield () => {
      var uCont = $completion;
      var timeoutCoroutine = new (TimeoutCoroutine())(timeMillis, uCont);
      coroutine._v = timeoutCoroutine;
      return setupTimeout(timeoutCoroutine, block);
    };
  } catch ($p) {
    if ($p instanceof TimeoutCancellationException()) {
      var e = $p;
      if (e.s17_1 === coroutine._v) {
        return null;
      }
      throw e;
    } else {
      throw $p;
    }
  }
}
var TimeoutCancellationExceptionClass;
function TimeoutCancellationException() {
  if (TimeoutCancellationExceptionClass === VOID) {
    class $ extends CancellationException() {
      static u17(message, coroutine) {
        var $this = this.n(message);
        captureStack($this, $this.t17_1);
        $this.s17_1 = coroutine;
        return $this;
      }
      static v17(message) {
        return this.u17(message, null);
      }
      n13() {
        var tmp0_elvis_lhs = this.message;
        // Inline function 'kotlin.also' call
        var this_0 = TimeoutCancellationException().u17(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, this.s17_1);
        initCause(this_0, this);
        return this_0;
      }
    }
    initMetadataForClass($, 'TimeoutCancellationException', VOID, VOID, [CopyableThrowable()]);
    TimeoutCancellationExceptionClass = $;
  }
  return TimeoutCancellationExceptionClass;
}
var TimeoutCoroutineClass;
function TimeoutCoroutine() {
  if (TimeoutCoroutineClass === VOID) {
    class $ extends ScopeCoroutine() {
      constructor(time, uCont) {
        super(uCont.mc(), uCont);
        this.a18_1 = time;
      }
      w11() {
        var delay = get_delay(this.cw_1);
        var tmp0_safe_receiver = this.cw_1.yc(Key_instance);
        var name = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h13_1;
        this.sx(TimeoutCancellationException_0(this.a18_1, delay, this, name));
      }
      qw() {
        return super.qw() + '(timeMillis=' + this.a18_1.toString() + ')';
      }
    }
    initMetadataForClass($, 'TimeoutCoroutine', VOID, VOID, [Runnable()], [0]);
    TimeoutCoroutineClass = $;
  }
  return TimeoutCoroutineClass;
}
function setupTimeout(coroutine, block) {
  var cont = coroutine.fz_1;
  var context = cont.mc();
  disposeOnCompletion(coroutine, get_delay(context).p13(coroutine.a18_1, coroutine, coroutine.cw_1));
  return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
}
function TimeoutCancellationException_0(time, delay, coroutine, coroutineName) {
  var tmp0_safe_receiver = isInterface(delay, DelayWithTimeoutDiagnostics()) ? delay : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(time, DurationUnit_MILLISECONDS_getInstance());
    tmp = tmp0_safe_receiver.q13(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp;
  var baseMessage = tmp1_elvis_lhs == null ? 'Timed out waiting for ' + time.toString() + ' ms' : tmp1_elvis_lhs;
  var tmp_0;
  if (!(coroutineName == null)) {
    // Inline function 'kotlin.text.replaceFirstChar' call
    var tmp_1;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(baseMessage) > 0) {
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      var this_0 = charCodeAt(baseMessage, 0);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$5 = toString(this_0).toLowerCase();
      var tmp0 = charCodeAt(tmp$ret$5, 0);
      // Inline function 'kotlin.text.plus' call
      var other = substring(baseMessage, 1);
      tmp_1 = toString(tmp0) + other;
    } else {
      tmp_1 = baseMessage;
    }
    tmp_0 = 'Coroutine "' + coroutineName + '" ' + tmp_1;
  } else {
    tmp_0 = baseMessage;
  }
  var message = tmp_0;
  return TimeoutCancellationException().u17(message, coroutine);
}
function *withTimeout(timeMillis, block, $completion) {
  if (timeMillis <= 0n)
    throw TimeoutCancellationException().v17('Timed out immediately');
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    return setupTimeout(new (TimeoutCoroutine())(timeMillis, uCont), block);
  };
}
//region block: exports
export {
  withTimeoutOrNull as withTimeoutOrNull3fn9ef0keo2ht,
  withTimeout as withTimeout3dbn27y1hxkws,
  TimeoutCancellationException as TimeoutCancellationException198b5zwr3v3uw,
};
//endregion

//# sourceMappingURL=Timeout.mjs.map
